import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Colors from '../colors';
const themes = {
  default: Colors.lightGray500,
  light: Colors.lightGray300
};
const DividerLine = styled.View`
  background-color: ${props => themes[props.theme]};
  width: 100%; 
  height: 1px;
`;
DividerLine.defaultProps = {
  theme: 'default'
};
DividerLine.propTypes = {
  theme: PropTypes.oneOf(['default', 'light'])
};
export default DividerLine;
//# sourceMappingURL=index.js.map